import React from 'react';
import styled from 'styled-components';

const Label = styled.div`
  font-size: 11px;
  line-height: 14px;
  font-weight: 600;
  opacity: 0.5;
`;

export default Label;
